import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { createDeferredRecoveryProvider } from '../lib/recovery';

export function Recover() {
  const navigate = useNavigate();
  const { isAuthenticated, wallet } = useAuth();
  const provider = useMemo(() => createDeferredRecoveryProvider(), []);
  const spikeRecord = useMemo(() => provider.getSpikeRecord(), [provider]);
  const capability = provider.getCapability();

  return (
    <main
      data-testid="recover-screen"
      data-recovery-state={spikeRecord.status}
      className="flex min-h-screen items-center justify-center px-4 pb-32 pt-10"
    >
      <section className="w-full max-w-[520px] rounded-xl border border-neutral-200 bg-white p-5 shadow-sm">
        <div className="mb-4">
          <p className="text-xs font-medium uppercase tracking-wide text-neutral-500">Recover</p>
          <h1 className="mt-1 text-2xl font-semibold text-neutral-900">Recovery deferred</h1>
          <p data-testid="recover-state" className="mt-2 text-sm text-neutral-600">
            Provider proof is pending. OwnYou is not exposing a mock recovery success path.
          </p>
        </div>

        <dl className="space-y-3 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm">
          <div>
            <dt className="font-medium text-amber-950">Current state</dt>
            <dd className="mt-1 text-amber-800">{spikeRecord.decision}</dd>
          </div>
          <div>
            <dt className="font-medium text-amber-950">Input required</dt>
            <dd data-testid="recover-input-kind" className="mt-1 text-amber-800">
              {capability.inputKind === 'none'
                ? 'None until a real provider primitive is proved'
                : capability.inputKind}
            </dd>
          </div>
          <div>
            <dt className="font-medium text-amber-950">Signed-in wallet</dt>
            <dd className="mt-1 break-all text-amber-800">
              {isAuthenticated && wallet?.address ? wallet.address : 'Not authenticated'}
            </dd>
          </div>
        </dl>

        <div className="mt-5 grid gap-2 sm:grid-cols-2">
          <button
            type="button"
            data-testid="recover-settings-link"
            onClick={() => navigate('/you/settings')}
            className="rounded-lg border border-neutral-200 px-3 py-2 text-sm font-medium text-neutral-700 transition-colors hover:bg-neutral-50"
          >
            Settings
          </button>
          <button
            type="button"
            data-testid="recover-audit-link"
            onClick={() => navigate('/you/settings/audit')}
            className="rounded-lg bg-neutral-900 px-3 py-2 text-sm font-medium text-white transition-colors hover:bg-neutral-800"
          >
            AuditLog
          </button>
        </div>
      </section>
    </main>
  );
}
